var _g, _path, _g2, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriceCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 344,
    height: 146,
    viewBox: "0 0 344 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10467_80035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 19C16 11.268 22.268 5 30 5H315C322.732 5 329 11.268 329 19V107C329 114.732 322.732 121 315 121H30C22.268 121 16 114.732 16 107V19Z",
    fill: "url(#paint0_linear_10467_80035)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 19C16.5 11.5442 22.5442 5.5 30 5.5H315C322.456 5.5 328.5 11.5442 328.5 19V107C328.5 114.456 322.456 120.5 315 120.5H30C22.5442 120.5 16.5 114.456 16.5 107V19Z",
    stroke: "url(#paint1_linear_10467_80035)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10467_80035",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 5,
    width: 313,
    height: 114
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 19.8164C15.5 12.3605 21.5442 6.31641 29 6.31641H314C321.456 6.31641 327.5 12.3606 327.5 19.8164V104.359C327.5 111.815 321.456 117.859 314 117.859H29C21.5442 117.859 15.5 111.815 15.5 104.359V19.8164Z",
    fill: "url(#paint2_linear_10467_80035)",
    stroke: "url(#paint3_linear_10467_80035)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10467_80035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.641 -45.219C302.774 14.4394 310.306 104.665 250.464 156.306C190.621 207.947 86.0659 201.447 16.9326 141.789C-52.2007 82.1303 -59.7325 -8.09554 0.109726 -59.7363C59.952 -111.377 164.507 -104.877 233.641 -45.219Z",
    fill: "url(#paint4_radial_10467_80035)",
    fillOpacity: 0.9
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M196 5H316C323.732 5 330 11.268 330 19V104C330 111.732 323.732 118 316 118H307.799L196 5Z",
    fill: "url(#paint5_linear_10467_80035)",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M121 118L330 118V20C330 12.268 323.732 6 316 6H226.843L121 118Z",
    fill: "url(#paint6_linear_10467_80035)",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10467_80035",
    x: 1,
    y: 0,
    width: 343,
    height: 146,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.225 0 0 0 0 0.206094 0 0 0 0 0.163125 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10467_80035"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10467_80035",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10467_80035",
    x1: 16,
    y1: 63.7163,
    x2: 309.59,
    y2: 63.7163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28324B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373D55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10467_80035",
    x1: 16,
    y1: 57.2817,
    x2: 309.589,
    y2: 58.3339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3DABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687722,
    stopColor: "#FCECD8",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCE8CE",
    stopOpacity: 0.37
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10467_80035",
    x1: 15,
    y1: 62.7828,
    x2: 328,
    y2: 62.7828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28324B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373D55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10467_80035",
    x1: 15,
    y1: 56.5399,
    x2: 327.998,
    y2: 57.7726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3DABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687722,
    stopColor: "#FCECD8",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCE8CE",
    stopOpacity: 0.37
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_10467_80035",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(139.842 60.8455) rotate(40.6446) scale(132.864 113.683)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5172"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#51568B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10467_80035",
    x1: 251.107,
    y1: 5,
    x2: 251.225,
    y2: 87.2642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10467_80035",
    x1: 156.46,
    y1: 112.592,
    x2: 214.647,
    y2: 2.1519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceCard);
export default __webpack_public_path__ + "static/media/price-card.7e3c6b0a691251726a7edb5f4a409c15.svg";
export { ForwardRef as ReactComponent };